import { Check, X, Minus } from "lucide-react";
import { COMPARISON } from "../data/mock";
import { useInView } from "../hooks/useInView";

const Cell = ({ value, isBlitz }) => {
  if (value === "yes") {
    return (
      <div className={`w-6 h-6 mx-auto rounded-full flex items-center justify-center ${isBlitz ? "bg-lime-500" : "bg-slate-400"}`}>
        <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />
      </div>
    );
  }
  if (value === "no") {
    return (
      <div className="w-6 h-6 mx-auto rounded-full bg-red-100 flex items-center justify-center">
        <X className="w-3.5 h-3.5 text-red-500" strokeWidth={3} />
      </div>
    );
  }
  return (
    <div className="w-6 h-6 mx-auto rounded-full bg-orange-100 flex items-center justify-center" title="Sometimes">
      <Minus className="w-3.5 h-3.5 text-orange-500" strokeWidth={3} />
    </div>
  );
};

export const ComparisonTable = () => {
  const [ref, isInView] = useInView();
  return (
    <section className="py-16 lg:py-20 bg-slate-50/70">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-10" ref={ref}>
          <span className="inline-block text-sm font-semibold text-sky-600 tracking-wider uppercase mb-4">
            Compare
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight mb-4">
            {COMPARISON.headline}
          </h2>
          <p className="text-slate-500">Transparent, side-by-side. No fluff.</p>
        </div>

        <div className={`bg-white rounded-3xl border border-slate-200 shadow-lg shadow-slate-900/5 overflow-hidden transition-all duration-700 ${isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="comparison-table">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-200">
                  {COMPARISON.columns.map((c, i) => (
                    <th
                      key={i}
                      className={`text-left px-4 sm:px-6 py-4 font-semibold ${
                        i === 1 ? "text-sky-700 bg-sky-50 relative" : "text-slate-600"
                      } ${i === 0 ? "w-1/2" : "text-center w-1/6"}`}
                    >
                      {i === 1 && (
                        <span className="absolute -top-2 left-1/2 -translate-x-1/2 text-[9px] font-bold uppercase tracking-wider bg-lime-500 text-slate-900 px-2 py-0.5 rounded-full">
                          Best
                        </span>
                      )}
                      {c}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {COMPARISON.rows.map((r, i) => (
                  <tr
                    key={i}
                    className={`border-b border-slate-100 last:border-b-0 hover:bg-slate-50/50 ${i % 2 ? "bg-slate-50/30" : ""}`}
                    data-testid={`comparison-row-${i}`}
                  >
                    <td className="px-4 sm:px-6 py-4 font-medium text-slate-700">{r.feature}</td>
                    <td className="px-4 sm:px-6 py-4 bg-sky-50/60"><Cell value={r.blitzwash} isBlitz /></td>
                    <td className="px-4 sm:px-6 py-4"><Cell value={r.local} /></td>
                    <td className="px-4 sm:px-6 py-4"><Cell value={r.franchise} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};
